package com.markettwits.waifupics.random.components.image_state.suceess

internal actual fun supportsBackdropBlur(): Boolean = true
